import { useAppDisplayModeContext } from '@archipro-design/aria';
import ArticlesCarouselDesktop from '../../../articles/component/articles-carousel/ArticlesCarousel.desktop';
import { useFetcher } from '@remix-run/react';
import type { ArticleGroupTypes } from '~/modules/articles/type';
import { useEffect } from 'react';
// import ArticlesListMobile from '~/modules/articles/component/articles-carousel/ArticlesList.mobile';
import {
    type loader as articleLoader,
    HREF_ARTICLE_TILES,
} from '~/routes/remix-api.article.get-article-tiles';
import ArticlesList from '~/modules/articles/component/article-list/ArticleList';
import ArticleCarouselPlaceholder from '~/modules/articles/component/article-tile-skeleton/ArticleCarouselPlaceholder';

const LatestArticlesFooter: React.FC = () => {
    const { mobile: isMobile } = useAppDisplayModeContext();
    const fetcher = useFetcher<typeof articleLoader>();
    const articleTiles = fetcher.data;
    useEffect(() => {
        if (fetcher.state === 'idle' && fetcher.data == null) {
            fetcher.load(`${HREF_ARTICLE_TILES}?searchSort=latest`);
        }
    }, [fetcher]);

    const args = {
        title: 'LATEST',
        articleType: 'latest' as ArticleGroupTypes,
    };

    return !articleTiles ? (
        <ArticleCarouselPlaceholder title={args.title} />
    ) : (
        <>
            {isMobile ? (
                <ArticlesList {...args} articleTiles={articleTiles} />
            ) : (
                <ArticlesCarouselDesktop
                    {...args}
                    articleTiles={articleTiles}
                />
            )}
        </>
    );
};
export default LatestArticlesFooter;
